import { UwtType } from 'modules/types/LeasingCalculatorCodes';

export const removeArrayDuplicates = (array?: UwtType[]) =>
  array?.filter(
    (element, index, self) =>
      index === self.findIndex((e) => e.id === element.id),
  );

export const sortObjectsByName = (array?: UwtType[]) =>
  array?.slice().sort((a, b) => a.name.localeCompare(b.name));
